/**
 * Toggle Fullscreen
 *
 * following https://www.sitepoint.com/use-html5-full-screen-api/
 */

import React, { PropTypes } from 'react';

import MapControl from '../MapControl';

import './fullscreen.scss';

/* global document */
class FullScreenControl extends React.Component {
  constructor(props) {
    super(props);

    this.onControlClick = this.onControlClick.bind(this);
    this.onFullScreenChange = this.onFullScreenChange.bind(this);

    document.addEventListener('fullscreenchange', this.onFullScreenChange);
    document.addEventListener('webkitfullscreenchange', this.onFullScreenChange);
    document.addEventListener('mozfullscreenchange', this.onFullScreenChange);
    document.addEventListener('MSFullscreenChange', this.onFullScreenChange);
  }

  shouldComponentUpdate(nextProps) {
    return !(
      this.props.isFullScreen === nextProps.isFullScreen
    );
  }

  componentDidUpdate() {
    if (this.props.isFullScreen) {
      if (!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement)) {
        this.requestFullScreen();
      }
    } else {
      this.cancelFullScreen();
    }
  }

  onControlClick() {
    this.props.dispatch(this.props.toggleFullScreen());
    document.getElementById(this.props.rootDivId).dispatchEvent(new Event(this.props.isFullScreen ? 'fullscreen.off' : 'fullscreen.on'));
  }

    /**
     * Honor when full scren changes by Exit, F12 or what ever
     */
  onFullScreenChange() {
    if (this.props.isFullScreen && !(
            document.fullscreenElement ||
            document.webkitFullscreenElement ||
            document.mozFullScreenElement ||
            document.msFullscreenElement
        )) {
      this.props.dispatch(this.props.toggleFullScreen());
    }
  }

  /**
   * Request FullScreen Mode
   */
  requestFullScreen() {
    // @TODO: Figure out how to get the react root better
    const node = document.getElementById(this.props.rootDivId);

    if (node.requestFullscreen) {
      node.requestFullscreen();
    } else if (node.webkitRequestFullscreen) {
      node.webkitRequestFullscreen();
    } else if (node.mozRequestFullScreen) {
      node.mozRequestFullScreen();
    } else if (node.msRequestFullscreen) {
      node.msRequestFullscreen();
    } else {
        // @TODO: Add pseudo fullscreen
    }
  }

  /**
   * Cancel FullScreen Mode
   */
  cancelFullScreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    } else {
        // @TODO: Remove pseudo fullscreen
    }
  }


  render() {
    return (<MapControl position={this.props.position} className="palm-hide lap-hide">
      <a
        className={`${this.props.isFullScreen ? 'icon-icon_exit_fullscreen' : 'icon-icon_fullscreen'} leaflet-control-fullscreen text--blue-dark palm-hide lap-hide`}
        onClick={this.onControlClick}
        title="FullScreen"
      >
      </a>
    </MapControl>);
  }


}

FullScreenControl.propTypes = {
  position: PropTypes.string,
  isFullScreen: PropTypes.bool,
  rootDivId: PropTypes.string,
  toggleFullScreen: PropTypes.func
};

FullScreenControl.defaultProps = {
  position: 'topleft',
  isFullScreen: false,
  rootDivId: 'maptool',
  toggleFullScreen: () => {}
};

export default FullScreenControl;



/** WEBPACK FOOTER **
 ** ./core_components/FullScreen/index.js
 **/